import HttpRequest from './HttpRequest';

export default class ComponentPackingService extends HttpRequest {
  static endpoint = 'component-packaging-types';

  static async getAll() {
    this.endpoint = 'component-packaging-types';
    const response = await this.get();
    return response;
  }
}
